import { AxiosHttpServiceBuilder } from '@wallbox/http'
import { wapiRepositoryBuilder } from './WapiRepository'

export const wapiRepository = () => wapiRepositoryBuilder({
  httpService: new AxiosHttpServiceBuilder()
})
